
import React,{useState,useEffect} from 'react'
import Parosidebar from '../Components/Parosidebar';
import Paronavbar from '../Components/Paronavbar';
import DepartmentMain from '../Components/DepartmentMain';
import { Link } from 'react-router-dom';

const Department = () => {
    
  
     
 
  
  
    return (
      <div className='parop-container' id="Paro-dashboard">
      
        <DepartmentMain/>
  
        
      </div>
    )
}

export default Department